import React from 'react';
import { Icon } from '../../components/Icon';
import { Pagination } from '../../components/ui/Pagination';
// import type { Person } from '../../types/person';
// import QrButton from '../../components/QrButton';
import type { Evento } from '../../types/evento';

interface TableProps {
  data: Evento[];
  loading: boolean;
  currentPage: number;
  totalPages: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onRefresh: () => void;
  // onStateChange: (state: number, employee_id: string) => void;
  updating: boolean
}

export const Table: React.FC<TableProps> = ({
  data,
  loading,
  currentPage,
  totalPages,
  pageSize,
  total,
  onPageChange,
  // onRefresh,
  // onStateChange,
  // updating
}) => {

  // const [updatePersonId, setUpdatePersonId] = useState("");
  // const handleView = (empleado: Empleado) => {
  //   alert(`Ver detalles de: ${empleado.nombre}`);
  //   // Implementar navegación a vista de detalles
  // };

  // const handleEdit = (empleado: Empleado) => {
  //   alert(`Editar empleado: ${empleado.nombre}`);
  //   // Implementar navegación a formulario de edición
  // };

  // const handleStatus = (state: string | null, employee_id: string | null) => {
  //   if (!state || !employee_id)
  //     return
  //   if (state !== '1' && state !== '2')
  //     return

  //   const newState = state === '1' ? 2 : 1;
  //   setUpdatePersonId(employee_id)
  //   // onStateChange(newState, employee_id);
  // }

  const getStatusColor = (status: string) => {
    switch (status) {
      case '2': return 'text-green-500 dark:text-green-400 bg-green-100';
      case '11': return 'text-red-500 dark:text-red-400 bg-red-100';
      default: return 'text-gray-500 dark:text-gray-400 bg-gray-100';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case '2': return 'Autorizado';
      case '11': return 'No Autorizado';
      default: return 'Desconocido';
    }
  };

  // const handleDelete = async (empleado: Empleado) => {
  //   if (window.confirm(`¿Estás seguro de eliminar a ${empleado.nombre}?`)) {
  //     try {
  //       // Aquí iría la llamada a la API para eliminar
  //       // await visitasApi.deleteEmpleado(empleado.id);
  //       alert(`Empleado ${empleado.nombre} eliminado`);
  //       onRefresh();
  //     } catch (error) {

  //       alert(`Error al eliminar el empleado: ${error}`);
  //     }
  //   }
  // };

  return (
    <div className="card p-1 lg:p-4">
      <div className="p-6 border-b border-gray-200 dark:border-gray-700">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            Lista de Accesos
          </h3>
        </div>
      </div>

      <div className="overflow-x-auto ">
        <table className="w-full border border-gray-200 ">
          <thead className="bg-gray-50 dark:bg-gray-700 ">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Usuario
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Creado en
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Facial
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Estado
              </th>
              {/* <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Acciones
              </th> */}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {loading ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                    <span className="text-gray-600 dark:text-gray-300">Cargando visitas...</span>
                  </div>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <Icon name="users" className="w-12 h-12 text-gray-400" />
                    <span className="text-gray-500 dark:text-gray-400 text-lg">
                      No se encontraron visitas
                    </span>
                    <span className="text-gray-400 dark:text-gray-500 text-sm">
                      Intenta ajustar los filtros de búsqueda
                    </span>
                  </div>
                </td>
              </tr>
            ) : (
              data.map((person) => (
                <tr
                  key={person.accesos_id}
                  className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="w-16 h-16 rounded-lg flex items-center justify-center overflow-hidden">
                        {person?.photo_base64 ? (
                          <img
                            src={person.photo_base64}
                            alt={`${person.name_person} `}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full bg-gray-300 dark:bg-gray-600 rounded-lg flex items-center justify-center">
                            <Icon name="user" className="w-12 h-12 text-gray-400" />
                          </div>
                        )}
                      </div>

                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900 dark:text-white">
                          {person.name_person}
                        </div>
                        <div className="text-sm text-gray-500 dark:text-gray-400">
                          {person.employeenostring}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900 dark:text-white">
                      {person.created_at}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900 dark:text-white">
                      {person.devices_id === "1" ? 'Facial Registro' :
                        person.devices_id === "2" ? 'Facial Ingreso' :
                          person.devices_id === "3" ? 'Facial Salida' :
                            person.devices_id}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold  ${person.events_id ? getStatusColor(person.events_id)
                      : 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200'
                      }`}>{person.events_id ? getStatusText(person.events_id) : "N/A"}</span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      {totalPages > 1 && (
        <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            total={total}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};